export default __webpack_public_path__ + "forms.zh-cn.1762841572775.json";